import { OnInit } from "@angular/core";
var PartnerFillFormComponent = /** @class */ (function () {
    function PartnerFillFormComponent(rest) {
        this.rest = rest;
        this.model = [];
        this.currentPage = 1;
        this.limit = 40;
        this.total = 0;
        this.totalPages = 1;
    }
    PartnerFillFormComponent.prototype.ngOnInit = function () {
        this.getAllVisit();
    };
    PartnerFillFormComponent.prototype.getAllVisit = function () {
        var _this = this;
        var auth = JSON.parse(localStorage.getItem("partnerAuthen"));
        if (auth) {
            var partner_id = auth.partner_id;
            this.rest
                .getAllFillForm(partner_id, this.currentPage, this.limit)
                .subscribe(function (rs) {
                _this.model = rs.data;
                _this.total = rs.total;
                _this.totalPages = rs.totalPages;
                console.log("Response: ", rs);
            });
        }
    };
    PartnerFillFormComponent.prototype.goToPage = function (page) {
        if (page < 1 || page > this.totalPages)
            return;
        this.currentPage = page;
        this.getAllVisit();
    };
    Object.defineProperty(PartnerFillFormComponent.prototype, "pages", {
        get: function () {
            var total = this.totalPages;
            var cur = this.currentPage;
            if (total <= 7)
                return Array.from({ length: total }, function (_, i) { return i + 1; });
            var result = [1];
            if (cur > 3)
                result.push("...");
            for (var i = Math.max(2, cur - 1); i <= Math.min(total - 1, cur + 1); i++)
                result.push(i);
            if (cur < total - 2)
                result.push("...");
            result.push(total);
            return result;
        },
        enumerable: true,
        configurable: true
    });
    return PartnerFillFormComponent;
}());
export { PartnerFillFormComponent };
